module.exports = __webpack_public_path__ + "img/waves-1.05eb070e.jpg";